module.exports = __webpack_public_path__ + "media/images/prizes__prizeFg--6-1ef8b673723292360cd5c524a58fea61.png";